






















import { Component, Vue } from 'vue-property-decorator';
import ProjectForm from './projectForm.vue';
import { projectManage } from '../project';
import EditTeams from '../../components/editTeams.vue';
import EditUsers from '../../components/editUsers.vue';


@Component({
  components: {
    ProjectForm,
    EditTeams,
    EditUsers,
  },
})
export default class ProjectModal extends Vue {
  private componentName = 'project-form';
  private type = 'add';
  private visible = false;
  private title = this.$t('project.editProject').toString();
  private teams: ITeam.IResponse.ITeamInfo[] = [];
  private managers: IUser.IResponse.IUserDetailInfo[] = [];
  public showModal(component = 'project-form', type: 'add' | 'del' = 'add') {
    this.visible = true;
    this.componentName = component;
    if (component === 'edit-teams') {
      this.type = type;
      this.title = this.$t('project.updateTeam').toString();
      this.teams = projectManage.editData.projectInfo?.teams || [];
      return;
    }
    if (component === 'edit-managers') {
      this.type = type;
      this.title = this.$t('project.updateManager').toString();
      this.managers = projectManage.editData.projectInfo?.managers || [];
      return;
    }
    if (projectManage.editData.isCreate) {
      this.title = this.$t('project.createProject').toString();
    } else {
      this.title = this.$t('project.editProject').toString();
    }
  }
  public addTeams(teamIds: string[]): Promise<string> {
    return projectManage.requestAddTeams(teamIds);
  }
  public delTeams(teamIds: string[]): Promise<string> {
    return projectManage.requestDeleteTeams(teamIds);
  }
  public addUsers(userIds: string[]): Promise<string> {
    return projectManage.requestAddUsers(userIds);
  }
  public delUsers(userIds: string[]): Promise<string> {
    return projectManage.requestDeleteUsers(userIds);
  }
}
